import React from "react";
import Slider from "react-slick";
import residentialImg from "../img/envision/about/nature/360_F_199850553_BQkLfMhn0yjxf5SSTL0XBbdCvbWNNvlP.jpg";
import cmImg from "../img/envision/about/nature/360_F_835088954_osf4R1XWHyyeM2gs7Cv1QNLUq6uAWmtw.jpg";
import hospitalityImg from "../img/envision/about/nature/circuit-sustainability-41a61j51yyxbvc9z.jpg";
import sshImg from "../img/Hospitality Interiors 3.jpg";
import specialtyImg from "../img/Untitled-6.jpg";
import galleryImg6 from "../img/ssh-img.png";
import galleryImg7 from "../img/image-7.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Aboutsustainablefirstsection  from './Aboutsustainablefirstsection'


import AboutSustanbilitysecondsection from './AboutSustanbilitysecondsection'


const AboutUsSustainbility = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true, // Disable next/prev arrows
  };

  return (
    <section style={{ backgroundColor: "#dae2e3" }}>
      <div className="container-fluid" style={{ padding: "0px", overflow: "hidden" }}>
        <div className="row">
          <div className="col-lg-12">
            <Slider {...settings}>
              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${residentialImg})`,
                    height: "750px", // Increased height for image
                    backgroundSize: "cover", // Ensure the image covers the section
                    backgroundPosition: "center", // Center the image
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">
                            <div className="bread-title" style={{ fontSize: '2.5rem', fontWeight: '700', letterSpacing: '2px', display: 'block' }}>BUILDING A BETTER TOMMOROW</div>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${cmImg})`,
                    height: "750px", // Increased height for image
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">
                          <div className="bread-title" style={{ fontSize: '2.5rem', fontWeight: '700', letterSpacing: '2px', display: 'block' }}>DESIGNING A SUSTAINABLE TOMMOROW TOGETHER</div>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${hospitalityImg})`,
                    height: "750px", // Increased height for image
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">
                          <div className="bread-title" style={{ fontSize: '2.5rem', fontWeight: '700', letterSpacing: '2px', display: 'block' }}>DESIGNING A SUSTAINABLE TOMMOROW TOGETHER</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Slider>
          </div>
        </div>
      </div>
      <Aboutsustainablefirstsection />

      <AboutSustanbilitysecondsection />
    </section>
    
  );
};

export default AboutUsSustainbility;
